module.exports = __webpack_public_path__ + "static/media/bg_middle.907c825a.png";